import { MdChat, MdKeyboardArrowRight } from 'react-icons/md';

type Props = {
  onConfirm: () => void;
};

export default function CandidatesUnreadMessageBanner({ onConfirm }: Props) {
  return (
    <div className="flex items-center justify-between bg-[#fff7ec] px-lg py-xs">
      <div className="flex items-center gap-xs">
        <MdChat size={20} className="text-accent2" />
        <p className="text-heading-3xs text-main">未読メッセージがあります</p>
      </div>
      <button
        type="button"
        onClick={onConfirm}
        className="flex h-8 items-center gap-xxs rounded-sm px-xs hover:opacity-60"
      >
        <span className="text-button-sm text-accent2">メッセージを確認</span>
        <MdKeyboardArrowRight size={12} className="text-accent2" />
      </button>
    </div>
  );
}
